import './Description.scss';

const Description = () => (
  <div className="descriptionContainer">
    <div className="descriptionContainer__item">
      Comprar productos de segunda mano es una forma de consumo amigable con el
      medio ambiente.
    </div>
    <div className="descriptionContainer__item">
      Dale una nueva vida a tu casa y venda los trastos del año pasado.
    </div>
    <div className="descriptionContainer__item">
      Comprando productos de segunda mano apoyas la economía local y la
      creatividad.
    </div>
  </div>
);

export default Description;
